import { render, staticRenderFns } from "./AssetCard.vue?vue&type=template&id=0105051b&scoped=true&"
import script from "./AssetCard.vue?vue&type=script&lang=js&"
export * from "./AssetCard.vue?vue&type=script&lang=js&"
import style0 from "./AssetCard.vue?vue&type=style&index=0&id=0105051b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105051b",
  null
  
)

export default component.exports